// packages/shared-hooks/src/leads/usePatchLead.ts
//
// `PATCH /leads/:id` — partial field edit. `clientId` is the bind/unbind
// slot; passing `null` unbinds (emits `LEAD_CLIENT_UNBOUND` backend-side).
// Stage transitions, claim, archive/restore, and assignment live on their
// own endpoints with side effects; do NOT patch those slots here.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { LeadListItemSchema, type LeadListItem, type PatchLeadInput } from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { leadsKeys } from './keys.js';

export function usePatchLead(id: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<LeadListItem, unknown, PatchLeadInput>({
    mutationFn: (input) =>
      client.patch<LeadListItem>(`/leads/${id}`, input, {}, LeadListItemSchema),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: leadsKeys.all });
      void qc.invalidateQueries({ queryKey: leadsKeys.detail(id) });
    },
  });
}
